import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { hasPermission } from '@/hooks/useBackendMenu'
import { Checkbox } from '@mui/material'
import { Treinamento, treinamentos } from 'service/api'
import { toast } from 'sonner'

/**
 * Célula da coluna Cobrança: marcar/desmarcar dispara o PATCH na hora, sem
 * abrir o modal de edição. Molde de `SwitchModulo`.
 */
export default function CheckboxCobranca(
    params: GridCellParams<any, Treinamento>,
) {
    const cobranca = !!params.value
    const clienteId = params.row.clienteId

    const { mutateAsync, isLoading } = treinamentos.mutations.useUpdate({
        invalidateQuery: true,
        queryParams: { clienteId: String(clienteId) },
    })

    const handleChange = () =>
        mutateAsync(
            { id: params.row.id, cobranca: !cobranca },
            {
                onSuccess: () => {
                    toast.success(
                        `Treinamento ${
                            cobranca ? 'desmarcado' : 'marcado'
                        } para cobrança!`,
                    )
                },
                onError: () => {
                    toast.error('Erro ao alterar a cobrança!')
                },
            },
        )

    return (
        <Checkbox
            checked={cobranca}
            disabled={isLoading || !hasPermission(['update', 'Treinamentos'])}
            color="primary"
            size="small"
            onChange={handleChange}
        />
    )
}
